import { Heading, Text } from '@lmc/ui-kit/src/general'
import { Spinner } from 'components/generic'
import dayjs from 'dayjs'
import { NAMESPACE } from 'locale'
import { noticeboardConstants } from 'locale/noticeboard'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import useLastUnreadNotice from 'screens/Noticeboard/hooks/useLastUnreadNotice'
import styled from 'styled-components'
import Loudspeaker from './Loudspeaker'

const NoticeBanner = () => {
  const { t } = useTranslation(NAMESPACE.NOTICEBOARD)

  const { isLoading, result: lastUnreadNotice } = useLastUnreadNotice()

  if (isLoading) {
    return <Spinner />
  }

  if (lastUnreadNotice) {
    const noticeUrl = `/noticeboard/${lastUnreadNotice.id}`

    return (
      <Wrapper>
        <Banner>
          <NoticeContainer>
            <Loudspeaker />
            <LastUnreadNotice>
              <Top level={2}>
                {dayjs(lastUnreadNotice.createdOn).format('YYYY-MM-DD h:mm A')}
              </Top>
              <Bottom level={5} weight="bold">
                {lastUnreadNotice.title}
              </Bottom>
            </LastUnreadNotice>
          </NoticeContainer>
          <CtaContainer to={noticeUrl}>
            <ReadMore> {t(noticeboardConstants.READ_MORE)}</ReadMore>
          </CtaContainer>
        </Banner>
      </Wrapper>
    )
  }

  return null
}

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`

const Banner = styled.div`
  padding: 16px 24px;
  box-sizing: border-box;
  background: rgba(46, 185, 255, 0.05);
  border: 1px solid rgba(46, 185, 255, 0.2);
  width: 720px;
  border-radius: 9px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`

const NoticeContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 24px;
`

const LastUnreadNotice = styled.div`
  display: flex;
  flex-direction: column;
`

const Top = styled(Text)`
  color: ${(props) => props.theme.color.neutral.color5};
`

const Bottom = styled(Heading)`
  color: ${(props) => props.theme.color.neutral.color3};
`

const CtaContainer = styled(Link)`
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
`

const ReadMore = styled(Text)`
  color: ${(props) => props.theme.color.status.primary};
  white-space: nowrap;
`

export default NoticeBanner
